module.exports = __webpack_public_path__ + "img/logo_st.fe2b2047.png";